import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';
import { createStore } from './create-store';

const DEFAULT_DATE_RANGE = [dayjs().subtract(1, 'months'), dayjs()];

export interface IStatisticProfitFilter {
  date?: Dayjs[];
  comparisonDate?: Dayjs[];
  userId?: number;
}

type TState = {
  filters: IStatisticProfitFilter;
};

type TActions = {
  setFilters: (value: IStatisticProfitFilter | undefined) => void;
};

export const useStatisticProfitFilterStore = createStore<TState & TActions>(
  (set) => ({
    filters: { date: DEFAULT_DATE_RANGE },
    setFilters: (filters: IStatisticProfitFilter | undefined) => set((state) => ({ ...state, filters })),
  }),
  'statistic-profit-filters-store',
);
